export default "__VITE_ASSET__ba4102d4__"